import { AsyncPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { SupportConversationsService } from './support-conversations.service'

/** How many customers are waiting on a reply, across every environment the app reads. */
@Component({
  selector: 'app-conversations-waiting-badge',
  standalone: true,
  imports: [AsyncPipe],
  templateUrl: './conversations-waiting-badge.component.html',
  styleUrl: './conversations-waiting-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ConversationsWaitingBadgeComponent {
  readonly waiting$ = inject(SupportConversationsService).waitingCount()
}
